// import { trackerWind } from "@gaoding/gd-tracker";
import { isSpiderClient } from "@/utils/isSpider";
import { merge } from "lodash";
/**
 * 埋点方法
 * 无垠埋点与百度埋点上报方法
 * @param {Object} data 埋点数据
 * @param {Object} option  额外配置
 * @param {Boolean=} option.bd_disabled 禁止百度埋点上报
 * @param {Boolean=} option.gd_disabled 禁止稿定埋点上报
 * @param {Object=} option.bd_ext 百度扩展属性，百度埋点需要上传的独特属性
 */
export default async function reporter(
  data,
  { bd_disabled, gd_disabled, bd_ext = {} } = {}
) {
  try {
    // 爬虫、或者tracker脚本加载失败时，不进行上报
    if (!window.gdTracker || isSpiderClient()) {
      return;
    }

    const { trackerWind } = window.gdTracker;

    // 百度自定义事件埋点
    if (window._hmt && !bd_disabled) {
      const evnet_name = data.bd_event || data.event_name;
      delete data.bd_event;
      // eslint-disable-next-line no-undef
      _hmt.push([
        "_trackCustomEvent",
        evnet_name,
        // http://www.chinamootools.com/object.html
        merge(data, bd_ext),
      ]);
    }

    // 禁止稿定上报
    if (gd_disabled) return;

    const event_name = data.event_name;
    delete data.event_name;

    if (event_name === "trackPageView") {
      trackerWind.set("event", {
        page_params: data.page_params,
        source_page: data.source_page,
      });
    }

    if (data.page_nm === "主题页") {
      data.scene_name = document.querySelector(
        "[data-topic-subtitle]"
      )?.innerText;
    }

    if (trackerWind[event_name]) {
      if (event_name === "login") {
        trackerWind.login(data.userId, {
          type: 1,
          vipLevel: 0,
          track: true,
          ...data,
        });

        trackerWind.set("common", {
          is_login: 1,
        });
      } else {
        trackerWind[event_name](data);
      }
    } else {
      trackerWind.trackEvent(event_name || data.event, data);
    }
  } catch (error) {
    console.error("tracker reporter failed");
    console.error(error);
  }
}
